import { onMounted, onUnmounted, ref } from 'vue'

export function useMediaQuery(query: string) {
  const matches = ref(false)

  const updateMatches = () => {
    matches.value = window.matchMedia(query).matches
  }

  onMounted(() => {
    updateMatches()
    window.addEventListener('resize', updateMatches)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateMatches)
  })

  return matches
}

// 미리 정의된 미디어 쿼리를 제공하는 함수들
export function useIsMobile() {
  return useMediaQuery('(max-width: 1365px)')
}

export function useIsDesktop() {
  return useMediaQuery('(min-width: 1366px)')
}